import React, { useContext } from "react"
import { PageLayout, PageTitle } from "../components"
import { Container, Image } from "react-bootstrap"
import { Link, graphql } from "gatsby"
import { ThemeContext, SEO } from "../utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ data }) => {
  // const { unemployed, firstName, lastName, occupation1 } = data.site.siteMetadata
  const MediaLink = ({ title, author, link }) => (
    <li key={title} style={{ color: "gray" }}>
      <a rel="noopener noreferrer" href={link}>
        {title}
      </a>
      &nbsp;-<i>{author}</i>
    </li>
  )

  const {
    author,
    occupation,
    readingList,
    showsList,
    designations,
    unemployed,
  } = data.site.siteMetadata
  const { toString } = useContext(ThemeContext)

  const bookLinks = readingList.map(book => MediaLink(book))
  const showLinks = showsList.map(show => MediaLink(show))

  return (
    <PageLayout>
      <SEO title="About Me" />
      <PageTitle title="Yashaswi Karnati" />
      
      <Container>
        <Image
          rounded
          width="140"
          height="140"
          src={`../../icons/luke-${toString()}.png`}
          alt={author}
        />
        <article className="w-75 m-auto pt-2 text-justify">
          <p className="text-center">
            {designations.map((attr, i) => (
              <span key={attr}>
                &nbsp;<b>{attr}</b>&nbsp;
                {i < designations.length - 1 && <>||</>}
              </span>
            ))}
          </p>
          <p className="i-5 mt-4 pt-2">
            Hello there! My name is <b>{`${author}`}</b>. I am a&nbsp;
            <a
              href="https://www.dictionary.com/e/fictional-characters/padawan/"
              target="_blank"
              rel="noopener noreferrer"
            >
              padawan
            </a>
            &nbsp;
            <b>{occupation}</b> pursuing PhD in Computer Science, under the supervision of 
            &nbsp;
            <a
              href="https://sanjayranka.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prof. Sanjay Ranka
            </a> and
            &nbsp;
            <a
              href="https://www.cise.ufl.edu/~anand/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prof. Anand Rangarajan. 
            </a>
           
            {/* &nbsp;My current research focuses on developing ML, AI based algorithms to tackle real world problems in 
            Intelligent Transportation Systems (ITS) and smart health care. */}
            
          </p>
          <p className="i-5">
            I recieved my 
            Masters in Computer Science from&nbsp; 
            <a
              href="https://www.ufl.edu/"
              target="_blank"
              rel="noopener noreferrer"
            >
             University of Florida (Go Gators!)
            </a> in 2020 and 
            Bachelors in Electrical Engineering from&nbsp;
            <a
              href="https://www.iitism.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
             Indian Institute of Technology(ISM)-
            Dhanbad
            </a>
            &nbsp;in 2018. 
          </p>
          <p className="i-5">
          I am a machine learning researcher with diverse experience working on different domains including intelligent transportation, 
          climate science, data compression and health care. My research has spanned topics including predictive modeling, anomaly detection, 
          deep learning based digital twins, traffic signal control, traffic flow modelling, tensor decompositions,  machine learning based data 
          compression. Hands on experience with  large scale distributed frameworks for data generation, processing, model development and also 
          deriving key insights,  delivering to end stakeholders.  I am excited  about developing machine learning systems that has practical impact

          </p>
          {/* <p className="i-5">      
          </p>
          <p className="i-5">
            Check out my <Link to="/resume">experience</Link> to see what I've
            been up to! Or check out my <Link to="/blog">blog</Link> to see
            what's recently caught my eye!
          </p> */}
          
        </article>
        
        <article className="w-75 m-auto">
          { (
            <>
              <hr />
              <p className="unemployed">
                <small>
                  I am <b>currently looking for Internships</b>! If you
                  like what you <Link to="/resume">see</Link>, let's get
                  in&nbsp;
                  <a
                    href="mailto:yashaswikarnati@ufl.edu"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    touch!
                  </a> 
                  <br />
                  (yashaswikarnati[at]ufl[dot]edu) &nbsp;<br />
                  <a href="https://drive.google.com/uc?id=1O_sbiRLTi-2zsCfIo_qE2Ex_fgx5STI5&export=download" target="_blank" download> Resume
                  </a> 
                  &nbsp; 
                  <a href="https://scholar.google.com/citations?user=mC8YpQ4AAAAJ&hl=en&oi=ao" target="_blank" download> Google Scholar &nbsp; 
                  </a> 
                  <Link to="/resume">Experience</Link> <Link to="/blog">Publications</Link>

                  <br />
                </small>
              </p>
            </>
          )}
          <hr />
          {/* <h5 className="watch-list-title pt-4">
            Here are a couple of books from my reading list:
          </h5>
          <ul style={{ fontSize: "0.9rem", listStyle: "none" }}>{bookLinks}</ul>
          <h5 className="watch-list-title pt-4">
            Here are a couple of shows from my watch list:
          </h5>
          <ul style={{ fontSize: "0.9rem", listStyle: "none" }}>{showLinks}</ul>
          <h5 className="watch-list-title pt-4">
            Here are a couple of movies from my watch list:
          </h5>
          <p>
            <i>...waaaay too many to list.</i>
          </p> */}
        </article>
      </Container>
      
      <Container>
      <div className="d-md-inline-flex icons-container">
      <a
            href="https://www.github.com/yash-5595"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={["fab", "github"]}
              className="icons github"
              title="Github"
            />
          </a>
          <a
            href="https://linkedin.com/in/yashaswikarnati"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={["fab", "linkedin"]}
              className="icons linkedin"
              title="LinkedIn"
            />
          </a>
          <a
            href="mailto:yashaswikarnati@ufl.edu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={["fas", "envelope"]}
              className="icons mail"
              title="e-mail"
            />
          </a>
          <a href="https://drive.google.com/uc?id=1vg62MZC0NULnb1ROBaKhiVRnzzR2Thu-&export=download" target="_blank" download>
            <FontAwesomeIcon
              icon={["fas", "file-alt"]}
              className="icons file"
              title="Resume"
            />
          </a>
      </div>
      </Container>


      <Container>
      <article className="w-75 m-auto pt-2 text-justify">
      <hr />
      <p className="justnews unemployed">
          <b>News</b>
       </p>

       <p Container>

       <ul>
        <li><b> Jan 2022</b> -  Presented our work "Multiple Instance Learning Approach for Deriving Detector Channel to Phase Mappings for Signalized Intersections" at
       <a href="https://www.trb.org/AnnualMeeting/AnnualMeeting.aspx" target="_blank"> Transportation Research Board Annual Meeting 2022 
                  </a> , Washington D.C. Find the poster details <a href="https://drive.google.com/file/d/1nbmTEZVWZtArzzfhcf9s7sLbHue5e2Mx/view?usp=sharing" target="_blank"> here 
                  </a> </li>
        <li> <b> Nov 2021</b> Our Journal Article <a href="https://ieeexplore.ieee.org/document/9597466" target="_blank"> Subcycle Waveform Modelling of Traffic Intersections using Recurrent Attention Networks 
                  </a> published in Transactions 
        on Intelligent Transportation Systems (T-ITS).  </li>
        <li>
          
        <b> Oct 2021</b> Our Journal Article "<a href="https://www.mdpi.com/2076-3417/11/24/11637?utm_campaign=releaseissue_applsciutm_medium=emailutm_source=releaseissueutm_term=doilink180" target="_blank"> InterTwin - Deep Learning Approaches for Computing Measures of Effectiveness for Traffic Intersections 
                  </a> " published in Applied Sciences 
        , Special Issue on Machine Learning for Computer Engineering Applications.
          </li> 

          <li>
      <b> June 2021</b> Awarded Gartner Graduate Fellowship, Outstanding Student Award
      </li>

        <li> <b> Apr 2021</b> Out team won the Comotion Miami Mobility Challenge! Invited to colloborate with City of Miami and City of Gainesville for pilot implementation. Find the details here
        <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6812811361450553344" height="300" width="800"
         frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
        </li>
    
      <li> <b> Apr 2021</b> Thanks to University of Florida Transportation Institute for featuring my research. 
      <iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6781205080021483520" height="300" width="800" 
      frameborder="0" allowfullscreen="" title="Embedded post"></iframe>
        

      </li>

    
      </ul>
      
       
       </p>

          <hr />
      </article>
      </Container>

      
    </PageLayout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        unemployed
        occupation
        author
        designations
        readingList {
          title
          author
          link
        }
        showsList {
          title
          author
          link
        }
      }
    }
  }
`
